import { render, staticRenderFns } from "./common-dropdownlist.vue?vue&type=template&id=a1a20640&scoped=true&"
import script from "./common-dropdownlist.vue?vue&type=script&lang=js&"
export * from "./common-dropdownlist.vue?vue&type=script&lang=js&"
import style0 from "./common-dropdownlist.vue?vue&type=style&index=0&lang=less&"
import style1 from "./common-dropdownlist.vue?vue&type=style&index=1&id=a1a20640&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1a20640",
  null
  
)

export default component.exports